import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { filter } from 'rxjs';
import { AtomParams } from 'src/app/core/atom.service';
import { Filter, FilterData, FILTERS } from '../filter';
import { FilterEditorComponent } from '../filter-editor/filter-editor.component';

@Component({
  selector: 'atm-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit {
  @Output()
  readonly filtersChanged = new EventEmitter<AtomParams['filter']>();

  @Input() availableFilters: Filter[] = this.settedFilters;
  @Input() filtersSetted: AtomParams['filter'] | null = null;

  newFilter: FilterData | null = null;
  newFilterSetted = false;

  currentFilter: {
    available: boolean;
    setted: boolean;
    filter: Filter | null;
  } = {
    available: false,
    setted: false,
    filter: null,
  };

  @Input()
  get value(): AtomParams['filter'] {
    return this.filters.reduce((filters, filterData) => {
      console.log(filterData);
      const property = `${filterData.operation}.${filterData.filter.path}`;
      const value = filterData.value;
      const previousValue = filters![property] || '';
      if (!value) {
        return filters;
      }
      if (!previousValue) {
        return { ...filters, [property]: value };
      }
      return { ...filters, [property]: `${previousValue},${value}` };
    }, {} as AtomParams['filter']);
  }
  set value(filters: AtomParams['filter']) {
    this.filters = Object.entries(filters || {})
      .map(([key, value]) => {
        const [operation, path] = this.parseFilter(key);
        return {
          filter: this.availableFilters.find((filt) => filt.path === path),
          operation,
          value,
        } as FilterData;
      })
      .filter((config) => config.filter)
      .reduce((list, config) => {
        if (typeof config.value !== 'string') {
          return [...list, config];
        }
        const values = config.value.split(',');
        const splitFilters = values.map((value) => ({
          filter: config.filter!,
          operation: config.operation,
          value,
        }));
        return [...list, ...splitFilters];
      }, [] as FilterData[]);
  }
  private filters: FilterData[] = [];

  get filterList(): FilterData[] {
    return this.filters;
  }

  public defaultFilter: FilterData | null = null;

  constructor(
    public dialog: MatDialog,
    @Inject(FILTERS) public readonly settedFilters: Filter[]
  ) {}

  ngOnInit(): void {
    const currentFilter = this.availableFilters.find(
      (filter) => filter.type === 'current'
    );
    console.log(currentFilter)
    if (currentFilter) {
      this.currentFilter.available = true;
      this.currentFilter.setted = false;
      this.currentFilter.filter = currentFilter!;
    }
    const defaultFilterSetted = this.availableFilters.filter(
      (filter) => filter.defaultFilter
    );
    if (defaultFilterSetted && defaultFilterSetted.length > 0) {
      this.defaultFilter = {
        filter: defaultFilterSetted[0],
        operation: defaultFilterSetted[0].defaultOperation,
        value: '',
      };
    }
    if (this.filtersSetted) {
      this.value = this.filtersSetted;
      this.propagateChanges();
    }
  }

  setFilter($event: FilterData) {
    this.newFilter = $event;
    this.newFilterSetted = !!$event.value && !!$event.value.toString().length;
  }

  search() {
    if (this.newFilter) {
      this.filters = this.filters.concat(this.newFilter);
      this.propagateChanges();
    }
  }

  add(): void {
    this.openFilterEditor()
      .afterClosed()
      .pipe(filter((res) => !!res))
      .subscribe((res) => {
        res = this.setOptions(res!);
        this.filters = [...res];
        this.propagateChanges();
      });
  }

  editAt(index: number): void {
    if (this.filters[index].filter.removable) {
      this.openFilterEditor(this.filters[index])
        .afterClosed()
        .pipe(filter((res) => !!res))
        .subscribe((res) => {
          res = this.setOptions(res!);
          this.filters = [...res];
          this.propagateChanges();
        });
    }
  }

  removeAt(index: number): void {
    this.filters = this.filters.filter((_, i) => i !== index);
    this.propagateChanges();
  }

  private openFilterEditor(
    data?: FilterData
  ): MatDialogRef<FilterEditorComponent, FilterData[]> {
    return this.dialog.open(FilterEditorComponent, {
      data: {
        data: this.filters,
        filters: this.availableFilters,
        currentFilter: this.currentFilter,
        preset: data,
      },
      width: '620px',
    });
  }

  setOptions(res?: FilterData[]): FilterData[] {
    let filters = res || this.filterList;
    if (this.currentFilter.available) {
      const current = filters.find((r) => r.filter.type === 'current');
      this.currentFilter.setted = !!current && current.value === 'now';
      if (current && current.value !== 'now') {
        this.filters = this.filters.filter((r) => r.filter.type !== 'current');
        filters = filters.filter((r) => r.filter.type !== 'current');
      }
    }
    return filters;
  }

  private parseFilter(value: string): [string, string] {
    const parsed = /^([a-zA-Z0-9]*).([a-zA-Z0-9_.]*)$/.exec(value);
    if (parsed) {
      const [, operation, path] = parsed;
      return [operation, path];
    }
    throw new Error('Invalid filter');
  }

  private propagateChanges(): void {
    this.filtersChanged.next(this.value);
  }
}
